module.exports = __webpack_public_path__ + "img/tool_active_orange.87af86c0.svg";